import 'babel-runtime/core-js/promise';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import 'babel-runtime/helpers/toConsumableArray';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import { e as callback, n as getter, o as toArray, k as query, b as attr, g as append, a as on, c as hasAttr, f as tag } from './chunks/chunk-d93006cb.js';
import _Object$create from 'babel-runtime/core-js/object/create';
import 'babel-runtime/helpers/slicedToArray';
import { prototype as prototype$1 } from './pdr-app.js';
import DOMPurify from 'dompurify';

var update = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            element.textContent = '';
            toArray(element.attributes).forEach(function (attribute) {
              var sourceNameCandidate = attribute.name;
              switch (sourceNameCandidate) {
                case 'type':
                case 'stratsys-byos':
                case 'stratsys-configuration':
                case 'stratsys-flags':
                case 'stratsys-misc':
                case 'stratsys-products':
                  tryCreateIconFromSvg(element, sourceNameCandidate);
                  break;
                case 'fontawesome-regular':
                case 'fontawesome-light':
                case 'fontawesome-solid':
                case 'fontawesome-brands':
                case 'fontawesome-duotone':
                  tryCreateIconFromSprite(element, sourceNameCandidate, function (x) {
                    return x;
                  });
                  break;
                case 'materialdesign-action':
                case 'materialdesign-alert':
                case 'materialdesign-av':
                case 'materialdesign-communication':
                case 'materialdesign-content':
                case 'materialdesign-device':
                case 'materialdesign-editor':
                case 'materialdesign-file':
                case 'materialdesign-hardware':
                case 'materialdesign-image':
                case 'materialdesign-maps':
                case 'materialdesign-navigation':
                case 'materialdesign-notification':
                case 'materialdesign-places':
                case 'materialdesign-social':
                case 'materialdesign-toggle':
                  tryCreateIconFromSprite(element, sourceNameCandidate, function (x) {
                    return 'ic_' + x + '_24px';
                  });
                  break;
              }
            });

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function update(_x) {
    return _ref.apply(this, arguments);
  };
}();

var tryCreateIconFromSvg = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(element, sourceName) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            renderFromCache(element, sourceName);
            _context2.next = 3;
            return ensureSource(sourceName, function (source) {
              return _Object$keys(source).reduce(function (result, key) {
                result[key] = parseSvgSource(source[key]);
                return result;
              }, {});
            });

          case 3:
            render(element, sourceName, function (iconName) {
              return sources[sourceName][iconName];
            });

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function tryCreateIconFromSvg(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var tryCreateIconFromSprite = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(element, sourceName, spriteIdFunc) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            renderFromCache(element, sourceName);
            _context3.next = 3;
            return ensureSource(sourceName, function (source) {
              return parseSvgSource(source);
            });

          case 3:
            render(element, sourceName, function (iconName) {
              return query(sources[sourceName], '#' + spriteIdFunc(iconName));
            });

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function tryCreateIconFromSprite(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var ensureSource = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(sourceName, sourceValueFunc) {
    var source;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (sources[sourceName]) {
              _context4.next = 5;
              break;
            }

            _context4.next = 3;
            return loadSource(sourceName);

          case 3:
            source = _context4.sent;

            if (!sources[sourceName]) {
              // Skip if already set by another call
              sources[sourceName] = sourceValueFunc(source);
            }

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function ensureSource(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

var loadSource = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sourceName) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = sourceName;
            _context5.next = _context5.t0 === 'type' ? 3 : _context5.t0 === 'stratsys-byos' ? 6 : _context5.t0 === 'stratsys-configuration' ? 9 : _context5.t0 === 'stratsys-flags' ? 12 : _context5.t0 === 'stratsys-misc' ? 15 : _context5.t0 === 'stratsys-products' ? 18 : _context5.t0 === 'fontawesome-regular' ? 21 : _context5.t0 === 'fontawesome-light' ? 24 : _context5.t0 === 'fontawesome-solid' ? 27 : _context5.t0 === 'fontawesome-brands' ? 30 : _context5.t0 === 'fontawesome-duotone' ? 33 : _context5.t0 === 'materialdesign-action' ? 36 : _context5.t0 === 'materialdesign-alert' ? 39 : _context5.t0 === 'materialdesign-av' ? 42 : _context5.t0 === 'materialdesign-communication' ? 45 : _context5.t0 === 'materialdesign-content' ? 48 : _context5.t0 === 'materialdesign-device' ? 51 : _context5.t0 === 'materialdesign-editor' ? 54 : _context5.t0 === 'materialdesign-file' ? 57 : _context5.t0 === 'materialdesign-hardware' ? 60 : _context5.t0 === 'materialdesign-image' ? 63 : _context5.t0 === 'materialdesign-maps' ? 66 : _context5.t0 === 'materialdesign-navigation' ? 69 : _context5.t0 === 'materialdesign-notification' ? 72 : _context5.t0 === 'materialdesign-places' ? 75 : _context5.t0 === 'materialdesign-social' ? 78 : _context5.t0 === 'materialdesign-toggle' ? 81 : 84;
            break;

          case 3:
            _context5.next = 5;
            return import('./chunks/chunk-0b64ea1a.js');

          case 5:
            return _context5.abrupt('return', _context5.sent.default);

          case 6:
            _context5.next = 8;
            return import('./chunks/chunk-6dd37d25.js');

          case 8:
            return _context5.abrupt('return', _context5.sent.default);

          case 9:
            _context5.next = 11;
            return import('./chunks/chunk-23fe6915.js');

          case 11:
            return _context5.abrupt('return', _context5.sent.default);

          case 12:
            _context5.next = 14;
            return import('./chunks/chunk-63e880a7.js');

          case 14:
            return _context5.abrupt('return', _context5.sent.default);

          case 15:
            _context5.next = 17;
            return import('./chunks/chunk-22224a23.js');

          case 17:
            return _context5.abrupt('return', _context5.sent.default);

          case 18:
            _context5.next = 20;
            return import('./chunks/chunk-45a7be4f.js');

          case 20:
            return _context5.abrupt('return', _context5.sent.default);

          case 21:
            _context5.next = 23;
            return import('./chunks/chunk-96516df3.js');

          case 23:
            return _context5.abrupt('return', _context5.sent.default);

          case 24:
            _context5.next = 26;
            return import('./chunks/chunk-756e5e35.js');

          case 26:
            return _context5.abrupt('return', _context5.sent.default);

          case 27:
            _context5.next = 29;
            return import('./chunks/chunk-ec9b2059.js');

          case 29:
            return _context5.abrupt('return', _context5.sent.default);

          case 30:
            _context5.next = 32;
            return import('./chunks/chunk-c5ad2b9a.js');

          case 32:
            return _context5.abrupt('return', _context5.sent.default);

          case 33:
            _context5.next = 35;
            return import('./chunks/chunk-979e941a.js');

          case 35:
            return _context5.abrupt('return', _context5.sent.default);

          case 36:
            _context5.next = 38;
            return import('./chunks/chunk-ba727242.js');

          case 38:
            return _context5.abrupt('return', _context5.sent.default);

          case 39:
            _context5.next = 41;
            return import('./chunks/chunk-13fbc84e.js');

          case 41:
            return _context5.abrupt('return', _context5.sent.default);

          case 42:
            _context5.next = 44;
            return import('./chunks/chunk-d1d321e0.js');

          case 44:
            return _context5.abrupt('return', _context5.sent.default);

          case 45:
            _context5.next = 47;
            return import('./chunks/chunk-3eb2fe5e.js');

          case 47:
            return _context5.abrupt('return', _context5.sent.default);

          case 48:
            _context5.next = 50;
            return import('./chunks/chunk-fff334c0.js');

          case 50:
            return _context5.abrupt('return', _context5.sent.default);

          case 51:
            _context5.next = 53;
            return import('./chunks/chunk-d71e8fe9.js');

          case 53:
            return _context5.abrupt('return', _context5.sent.default);

          case 54:
            _context5.next = 56;
            return import('./chunks/chunk-f1c2a06b.js');

          case 56:
            return _context5.abrupt('return', _context5.sent.default);

          case 57:
            _context5.next = 59;
            return import('./chunks/chunk-7f030bf8.js');

          case 59:
            return _context5.abrupt('return', _context5.sent.default);

          case 60:
            _context5.next = 62;
            return import('./chunks/chunk-447a4995.js');

          case 62:
            return _context5.abrupt('return', _context5.sent.default);

          case 63:
            _context5.next = 65;
            return import('./chunks/chunk-fb902905.js');

          case 65:
            return _context5.abrupt('return', _context5.sent.default);

          case 66:
            _context5.next = 68;
            return import('./chunks/chunk-23b3cd7d.js');

          case 68:
            return _context5.abrupt('return', _context5.sent.default);

          case 69:
            _context5.next = 71;
            return import('./chunks/chunk-36a34785.js');

          case 71:
            return _context5.abrupt('return', _context5.sent.default);

          case 72:
            _context5.next = 74;
            return import('./chunks/chunk-e6abccac.js');

          case 74:
            return _context5.abrupt('return', _context5.sent.default);

          case 75:
            _context5.next = 77;
            return import('./chunks/chunk-4473026a.js');

          case 77:
            return _context5.abrupt('return', _context5.sent.default);

          case 78:
            _context5.next = 80;
            return import('./chunks/chunk-199ebd90.js');

          case 80:
            return _context5.abrupt('return', _context5.sent.default);

          case 81:
            _context5.next = 83;
            return import('./chunks/chunk-df14041f.js');

          case 83:
            return _context5.abrupt('return', _context5.sent.default);

          case 84:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function loadSource(_x9) {
    return _ref5.apply(this, arguments);
  };
}();
var _window = window,
    XMLSerializer = _window.XMLSerializer,
    Blob = _window.Blob;


var property = 'HTMLPdrIconElement';
var sources = {};
var blobCache = {};
var cachedSvgSprite = void 0;
var svgSprite = void 0;

var pdrIcon = window[property] = window[property] || document.registerElement('pdr-icon', {
  prototype: _Object$create(prototype$1, {
    createdCallback: callback(create$$),
    attachedCallback: callback(attach$$),
    attributeChangedCallback: callback(attribute$$),

    _style: getter(_style$$)
  })
});
var prototype = window[property].prototype;

function create$$(element) {
  element.__internal__ = {};
  attr(element, 'role', 'img');

  if (!cachedSvgSprite) {
    try {
      var cachedSVGSource = DOMPurify.sanitize(localStorage.getItem('pdr-icon-cached-svg-sprite') || '');
      cachedSvgSprite = new DOMParser().parseFromString(cachedSVGSource, 'image/svg+xml').documentElement;
    } catch (err) {
      cachedSvgSprite = null;
    }

    if (!cachedSvgSprite || cachedSvgSprite.tagName !== 'svg') {
      cachedSvgSprite = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      attr(cachedSvgSprite, 'id', 'pdr-icon-cached-svg-sprite');
      attr(cachedSvgSprite, 'xmlns', 'http://www.w3.org/2000/svg');
      cachedSvgSprite.style.display = 'none';
    }

    append(document.body, cachedSvgSprite);

    on(window, 'unload', function (e) {
      var cacheValue = new XMLSerializer().serializeToString(cachedSvgSprite);

      // TODO: Remove current localStorage cache and instead add ability for host to preload icons
      // 512kb cache limit, x2 for unicode
      if (cacheValue.length * 2 > 1024 * 512) {
        cacheValue = '';
      }

      localStorage.setItem('pdr-icon-cached-svg-sprite', cacheValue);
    });
  }

  if (!svgSprite) {
    svgSprite = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    attr(svgSprite, 'id', 'pdr-icon-svg-sprite');
    attr(svgSprite, 'xmlns', 'http://www.w3.org/2000/svg');
    svgSprite.style.display = 'none';
    append(document.body, svgSprite);
  }

  prototype$1.createdCallback.call(element);
}

function attach$$(element) {
  prototype$1.attachedCallback.call(element);
  update(element);
}

function attribute$$(element, name, oldValue, newValue) {
  var sourceNames = ['type', 'stratsys-byos', 'stratsys-configuration', 'stratsys-flags', 'stratsys-misc', 'stratsys-products', 'fontawesome-regular', 'fontawesome-light', 'fontawesome-solid', 'fontawesome-brands', 'fontawesome-duotone', 'materialdesign-maps', 'materialdesign-toggle'];
  if (name === 'base64' || sourceNames.indexOf(name) > -1) {
    update(element);
  }
}

function renderFromCache(element, sourceName) {
  if (hasAttr(element, 'base64')) {
    return;
  }

  element.textContent = ''; // Clear element in case multiple attributes are present
  element.style.backgroundImage = ''; // Reset base64 background

  var iconName = ensureIconName(attr(element, sourceName));
  if (!iconName) {
    return;
  }

  var iconId = 'cached-pdr-' + sourceName + '-' + iconName;
  append(element, createSvgIconElement(iconId));
}

function parseSvgSource(svgHtml) {
  var htmlParser = tag('div');
  // eslint-disable-next-line no-unsanitized/property
  htmlParser.innerHTML = svgHtml;
  return htmlParser.firstElementChild;
}

function render(element, sourceName, getIconFunc) {
  if (!hasAttr(element, sourceName)) {
    return;
  }

  element.textContent = ''; // Clear element in case multiple attributes are present
  element.style.backgroundImage = ''; // Reset base64 background

  var iconName = ensureIconName(attr(element, sourceName));
  if (!iconName) {
    return;
  }
  var iconId = 'pdr-' + sourceName + '-' + iconName;

  if (!query(svgSprite, '#' + iconId)) {
    var icon = getIconFunc(iconName);
    if (icon) {
      var iconCopy = icon.cloneNode(true);
      iconCopy.id = iconId;
      append(svgSprite, iconCopy);

      var cacheIconId = 'cached-' + iconId;
      var currentCachedIcon = query(cachedSvgSprite, '#' + cacheIconId);
      if (currentCachedIcon) {
        currentCachedIcon.remove();
      }
      var cachedIconCopy = iconCopy.cloneNode(true);
      cachedIconCopy.id = cacheIconId;
      append(cachedSvgSprite, cachedIconCopy);
    }
  }

  if (hasAttr(element, 'base64')) {
    setBase64Url(element, sourceName, iconName, iconId, query(svgSprite, '#' + iconId));
  } else {
    append(element, createSvgIconElement(iconId));
  }
}

function ensureIconName(name) {
  return !/[^a-zA-Z0-9-_]+/.test(name) && name.length < 500 ? name : null;
}

function setBase64Url(element, sourceName, iconName, iconId, symbol) {
  var color = attr(element, 'base64');
  var blobCacheKey = sourceName + '-' + iconName + '-' + color;
  if (!blobCache[blobCacheKey]) {
    var svgElement = createSvgIconElement(iconId);
    append(svgElement, symbol.cloneNode(true));
    svgElement.style.fill = attr(element, 'base64');

    var svgData = new XMLSerializer().serializeToString(svgElement);
    var blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    blobCache[blobCacheKey] = URL.createObjectURL(blob);
  }
  element.style.backgroundImage = 'url(\'' + blobCache[blobCacheKey] + '\')';
}

function createSvgIconElement(iconId) {
  var svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  var useElement = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  svgElement.setAttribute('focusable', false);
  useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + iconId);
  append(svgElement, useElement);
  return svgElement;
}

function _style$$(element) {
  var TAG = element.tagName;
  return '\n    ' + TAG + ' {\n      display: inline-block;\n      line-height: 0;\n      height: 1em;\n      width: 1em;\n      vertical-align: -0.125em;\n    }\n\n    ' + TAG + '[base64] {\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    ' + TAG + ' > svg {\n      display: inline-block;\n      fill: currentColor;\n      font-size: inherit;\n      height: 100%;\n      width: 100%;\n    }\n\n    #pdr-icon-cached-svg-sprite .fa-primary,\n    #pdr-icon-svg-sprite .fa-primary {\n      fill: currentColor !important;\n    }\n  ';
}

export default pdrIcon;
export { prototype };
